export const SET_EVENT_DETAILS = (state, data) => {
  state.eventDetails = data;
};

export const SET_LOADING = (state, data) => {
  state.loading = data;
};

export const OPEN_SNACKBAR = (state, snackbarContent) => {
  state.snackbarContent = snackbarContent;
};

export const SET_EXPIRATION_DIALOG = (state, expirationDialog) => {
  state.expirationDialog = expirationDialog;
};

export const SET_NAMED_TICKETS = (state, data) => {
  state.namedTickets = data;
};

export const SET_QUEUE = (state, data) => {
  state.queue = data;
};

export const SET_FINISHED_QUEUE = (state, data) => {
  state.finishedQueue = data;
};

export const SET_STORE_DETAILS = (state, data) => {
  state.storeDetails = data;
};

export const SET_SELECTED_LANGUAGE = (state, data) => {
  state.selectedLanguage = data;
};

export const CHECK = () => {};

export const SET_FIRST_PAYMENT = (state) => {
  state.firstPayment = true;
};

export const SET_PENDING_ORDER = (state, data) => {
  state.pendingOrder = data;
};

export const SET_ORDER_PRODUCTS = (state, data) => {
  state.orderProducts = data;
};
